import React from "react";
import { withStyles } from "@material-ui/core";
import SearchBox from "../../../../../common/SearchBox";
import DropYardGridFilter from "./DropYardGridFilter";
import ClearAllFilterButton from "../../../../../dataGrid/columnFilters/ClearAllFilterButton";

const styles = (theme) => ({
  headerStyle: {
    margin: "5px 0px",
    height: "30px",
    borderRadius: "4px 4px 0 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  headerLabel: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
  },
  headerIconStyles: {
    padding: "5px 10px",
    borderLeft: `1px solid ${theme.AppBGColor}`,
    color: theme.iconColor,
  },
  disableIcon: {
    cursor: "not-allowed",
    opacity: 0.7,
  },
  enableIcon: {
    cursor: "pointer",
  },
  iconLayout: {
    color: theme.iconColor,
    "&>span": {
      padding: "10px 10px",
      color: theme.iconColor,
    },
  },
  gridActionIcons: {
    display:"flex",
    "& $actionIcon": {
      paddingLeft: 10,
      "&:not(:last-child)": {
        borderRight: `1px solid ${theme.AppBGColor}`,
        paddingRight: 10,
      },
    },
  },
  actionIcon:{},
  pickupsFilterContainer: {
    marginRight: 8,
    marginTop: 3,
  },
});

const DropYardGridHeader = ({
  classes,
  updateQuickFilterText,
  selectGridFilter,
  terminalList,
  gridApi
}) => {
  return (
    <div className={classes.headerStyle}>
      <div>
        <span
          className={classes.headerLabel}
          data-automationid="DropYard-title"
        >
          Drop Yards
        </span>
      </div>
      <span className={classes.gridActionIcons}>
        <div
          className={`${classes.iconLayout} ${classes.pickupsFilterContainer} glHeaderIcons`}
        >
          <DropYardGridFilter
            options={terminalList}
            selectGridFilter={selectGridFilter}
          />
        </div>

        <ClearAllFilterButton gridApi={gridApi} />
        <SearchBox onChange={updateQuickFilterText} />
      </span>
    </div>
  );
};
export default withStyles(styles)(DropYardGridHeader);
